export function Avatar({ src, label, className = 'size-8 text-[11px]' }: { src: string | null; label: string; className?: string }) {
  const base = `${className} shrink-0 rounded-[9px]`
  if (src) return <img src={src} alt="" className={`${base} object-cover`} />
  return (
    <span className={`${base} grid place-items-center bg-ink-950/[0.06] font-mono font-medium tracking-wide text-ink-700`} aria-hidden="true">
      {label.slice(0, 2).toUpperCase()}
    </span>
  )
}
